<template>
    <div>
        <div class="row pv4">
            <div class="col-xs-10 col-md-9">
                <div class="th flex ba b--light-gray h2">
                    <img class="ph2" src="@/assets/img/icon_search_tools.svg"/>
                    <input @keyup.enter="submit" class="flex-auto input-reset bn outline-0" placeholder="Tool" v-model="search" />
                </div>
            </div>
            <div class="col-xs-2 col-md-3">
                <a @click="submit" class="th flex justify-center items-center bg-yellow button grow no-underline pointer">
                    <div class="dn dib-m black">Search</div>
                    <img class="dn-m" src="@/assets/img/icon_search_black.svg"/>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            search: this.$route.query.q
        };
    },
    methods: {
        submit() {
            this.$router.push({ path: '/search', query: { q: this.search } });
        }
    }
};
</script>
